import { useEffect, useState } from "react"
import { AnimatePresence, motion } from "framer-motion"

type Props = {
  phrases: string[]
  intervalMs?: number
  onIndexChange?: (index: number) => void
}

export default function RotatingPhrase({
  phrases,
  intervalMs = 2600,
  onIndexChange,
}: Props) {
  const safe = phrases?.length ? phrases : ["dormir melhor"]
  const [i, setI] = useState(0)

  useEffect(() => {
    onIndexChange?.(i)
  }, [i, onIndexChange])

  useEffect(() => {
    const t = window.setInterval(() => {
      setI((prev) => (prev + 1) % safe.length)
    }, intervalMs)
    return () => window.clearInterval(t)
  }, [intervalMs, safe.length])

  return (
    <span className="relative inline-block h-fit overflow-hidden align-baseline">
      <AnimatePresence initial={false} mode="wait">
        <motion.span
          key={safe[i]}
          initial={{ y: "100%" }}
          animate={{ y: "0%" }}
          exit={{ y: "-100%" }}
          transition={{ duration: 0.25, ease: [0.4, 0, 0.2, 1] }}
          className="block whitespace-nowrap"
        >
          {safe[i]}
        </motion.span>
      </AnimatePresence>
    </span>
  )
}